import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Admin from "@/pages/Admin";
import CustomSens from "@/pages/CustomSens";
import Values from "@/pages/Values";
import ValueDetail from "@/pages/ValueDetail";
import { AuthProvider } from "@/hooks/useAuth";

function App() {
  useEffect(() => {
    document.title = "Rumple's Values — Apex Legends Values for Cronus Zen";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/custom-sens" element={<CustomSens />} />
            <Route path="/values" element={<Values />} />
            <Route path="/values/:pkgId" element={<ValueDetail />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
